import axios from 'axios';

const BASE = '/api/auth';

export const sendOtp = (phone: string) =>
  axios.post(`${BASE}/send-otp`, { phone }).then(r => r.data.data);

export const verifyOtp = (phone: string, otp: string, session: string) =>
  axios.post(`${BASE}/verify-otp`, { phone, otp, session }).then(r => r.data.data);

export const loginWithPassword = (username: string, password: string) =>
  axios.post(`${BASE}/login`, { username, password }).then(r => r.data.data);
